
import React, {useState} from 'react';
import Hashtag from "./Hashtag";


function App({config}) {  

    return (
      <div className="component-view animate" data-animate="blendin 3s">
       
      

          <div  className="flex-row-view">
            <div className="view-30 animate" data-animate="blendin 4s">
              <img className="image-view" src="./images/fahne_.jpeg" />             
            </div>

            <div className="view-60 ">        
              {/* <div className="text-item text-center">Haltet Frau Musica in Ehren!</div>     */}
              {/* <div className="text-item text-center text-header" >Haltet Frau Musica in Ehren!</div> */}
              <div className="text-item text-block" >
            {config.name} setzt sich aus den unterschiedlichsten Stimmlagen zusammen – manche davon jung und andere schon sehr erfahren. 
            Als Chor ist es immer eine unserer Hauptaufgaben, die Zuhörer mit schöner Musik zu begeistern und positive Emotionen hervorzurufen. 
            Lernen Sie das Team kennen, das sich der Kreation schöner Harmonien gewidmet hat.
            </div>
         
            </div>
        </div>


        <div className="flex-row-view ">

         

                     
        
      </div> 
      </div>
            );
        }
    
    export default App;